import React, { useLayoutEffect, useState, Fragment, useEffect, use } from 'react'
import ReactDOM from "react-dom/client";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, SelectBox, CheckBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import { FundRequestService } from '../../../apis/apiServices/FundRequest';
// import { RadioGroup, RadioButton } from 'devextreme-react/radio-group';
import RadioGroup from 'devextreme-react/radio-group';
// import r
import Swal from 'sweetalert2';
import DataGrid, {
    Column, MasterDetail, Selection
} from "devextreme-react/data-grid";
import Popup from "devextreme-react/popup";

export default function ViewFundRequestComponent() {

    const user = useSelector((state) => state.user.data);
    const location = useLocation();
    const navigate = useNavigate();
    const { fundRequestId } = location.state || {};
    useLayoutEffect(() => {
        const initialize = async () => {
            document.querySelector("#pageTitle").innerHTML = "FR - Fund Request";
            await getFundRequestData(fundRequestId);
        };

        initialize();
    }, []);
    const [fundRequestData, setFundRequestData] = useState(null);
    const [approveItemRequest, setApproveItemRequest] = useState({
        selectedItems: []
    });
    const [remarksPopup, setRemarksPopup] = useState({
        isModalVisible: false,
        itemId: 0,
        remarks: "",
    });
    const [error, setError] = useState({});


    const getFundRequestData = async () => {
        try {
            let body = { 'fundRequestId': fundRequestId, 'userId': user?.userId }
            const response = await FundRequestService.getFundRequestDetailsByFRId(body)
            setFundRequestData(response?.data);
        } catch (error) {
            console.log("Error getFundRequestData===>", error);
        }
    }

    const validateApproveOrRejectFundRequest = () => {
        let isValid = true;
        let err = "";

        let isAnyItemSelected = fundRequestData?.items?.some(i => i?.isApproveRejectEnables);
        if (!isAnyItemSelected) {
            isValid = false;
            err = "Please select at least one request.";
            return { isValid, err };
        }


        setFundRequestData(prevState => {
            return {
                ...prevState,
                items: prevState?.items?.map((item) => {
                    if (item?.isApproveRejectEnables) {
                        if (!item?.approveRejectStatusId) {
                            isValid = false;
                            err = "Please select action type";
                        }
                        if (!item?.remarks) {
                            isValid = false;
                            err += (err) ? " and add remark." : "Please add remark.";
                        }
                    }
                    return item;
                })
            }
        })

        return { isValid, err };
    }
    const approveOrRejectFundRequest = async () => {
        try {
            let validate = validateApproveOrRejectFundRequest();
            if (!validate?.isValid) {
                Swal.fire({ icon: 'error', text: validate?.err });
                return;
            }

            let body = {
                fundRequestId: fundRequestId,
                items: fundRequestData?.items?.filter((filterItem) => filterItem?.isApproveRejectEnables)
                    ?.map((item) => ({
                        itemStatusId: item?.approveRejectStatusId,
                        approvedBy: user?.userId,
                        remarks: item?.remarks || "",
                        requestTypeId: 1,
                        requestId: fundRequestData?.fundRequestId,
                        requestSerialNo: fundRequestData?.serialNo,
                        requestItemId: item?.itemId,
                        requestItemSerialNo: item?.itemSerialNo,
                        stageIndex: item?.currentStageIndex,
                        backToStageIndex: 1
                    }))
            }

            const response = await FundRequestService.approveRejectFundRequest(body)


            if (response?.isSuccess) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: response?.message,
                }).then(() => {
                    navigate('/fund-request')
                })
            }
        } catch (error) {
            console.log("Error approveOrRejectFundRequest===>", error);
        }
    }

    const setIsRemarkModalVisible = (rowData) => {
        setRemarksPopup((prevState) => ({
            isModalVisible: true,
            ...rowData,
        }));
    };

    const renderCheckBoxCell = (rowData, container) => {
        // Render the React component inside the container
        const root = ReactDOM.createRoot(container);
        root.render(
            <CheckBox
                value={rowData?.isApproveRejectEnables || false}
                onValueChange={() => {
                    setFundRequestData(prevState => {
                        return {
                            ...prevState,
                            items: prevState?.items?.map((item) => item?.itemId === rowData?.itemId
                                ? {
                                    ...item,
                                    isApproveRejectEnables: !item?.isApproveRejectEnables
                                }
                                : item),
                        }
                    })
                }}
            />
        );
    };

    const renderApproveRejectRadioButtonCell = (rowData, container) => {
        let actionDetails = fundRequestData?.actionDetails;
        let lastStageIndex = actionDetails?.length;

        // Clear container first
        container.innerHTML = '';

        const innerDiv1 = document.createElement('div');
        const innerDiv2 = document.createElement('div');

        const outerDiv = document.createElement('div');
        outerDiv.className = 'actioncontainer';
        outerDiv.appendChild(innerDiv1);
        outerDiv.appendChild(innerDiv2);

        // Create Approve radio button
        const approveRadio = document.createElement('input');
        approveRadio.type = 'radio';
        approveRadio.name = `approveReject_${rowData.itemId}`; // unique name per row
        approveRadio.value = 'true';
        approveRadio.checked = rowData.approveRejectStatusId === rowData?.currentStageActionTypeId;
        approveRadio.addEventListener('change', () => {
            console.table(rowData)
            setFundRequestData(prevState => ({
                ...prevState,
                items: prevState.items.map(item =>
                    (item.itemId === rowData.itemId)
                        ? { ...item, approveRejectStatusId: rowData?.currentStageActionTypeId }
                        : item
                )
            }));
        });

        const approveLabel = document.createElement('label');
        approveLabel.className = 'btn btn-outline-primary btn-sm';
        approveLabel.style.marginRight = "4px"; // spacing between approve/reject
        approveLabel.appendChild(approveRadio);
        approveLabel.appendChild(
            document.createTextNode(
                actionDetails?.find(stage => stage?.stageIndex === (rowData?.currentStageIndex + 1))?.status || "Approve"
            )
        );


        // Create Reject radio button
        const rejectRadio = document.createElement('input');
        rejectRadio.type = 'radio';
        rejectRadio.name = `approveReject_${rowData.itemId}`; // same group name
        rejectRadio.value = 'false';
        rejectRadio.checked = rowData.approveRejectStatusId === 4;
        rejectRadio.addEventListener('change', () => {
            setFundRequestData(prevState => ({
                ...prevState,
                items: prevState.items.map(item =>
                    (item.itemId === rowData.itemId)
                        ? { ...item, approveRejectStatusId: 4 }
                        : item
                )
            }));
        });

        // Create Reject label (radio first, then text)
        const rejectLabel = document.createElement('label');
        rejectLabel.className = 'btn btn-outline-primary btn-sm';
        rejectLabel.style.marginLeft = "4px";
        rejectLabel.appendChild(rejectRadio);
        rejectLabel.appendChild(document.createTextNode("Back to Draft"));

        innerDiv1.appendChild(approveLabel);
        innerDiv1.appendChild(rejectLabel);

        // remarks starts from here.
        if (rowData?.remarks) {
            const remarksLabel = document.createElement('label');
            remarksLabel.style.marginLeft = "4px";
            remarksLabel.appendChild(document.createTextNode(rowData?.remarks));
            innerDiv2.appendChild(remarksLabel);
        }

        const addRemarksLabel = document.createElement('label');
        addRemarksLabel.className = 'btn btn-link btn-sm';
        //addRemarksLabel.style.marginLeft = "4px";
        const addRemarkIcon = document.createElement('i');
        addRemarkIcon.className = (rowData?.remarks) ? 'fas fa-pen' : 'far fa-comment-alt';
        addRemarkIcon.style.marginRight = "5px";
        const addRemarkLabel = document.createElement('label');
        addRemarksLabel.appendChild(addRemarkIcon);
        addRemarksLabel.appendChild(document.createTextNode(rowData?.remarks ? "Edit" : "Add remark"));
        addRemarksLabel.addEventListener('click', () => {
            setIsRemarkModalVisible(rowData);
        });
        innerDiv2.appendChild(addRemarksLabel);


        container.appendChild(outerDiv);
    };


    return (
        <Fragment>
            <div className="content">
                <div className='card top-bottom' >
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-6 col-sm-12'>
                                <Button
                                    text={fundRequestData?.nextUserStatusText ? fundRequestData?.nextUserStatusText : "Submit Request"}
                                    icon="check"
                                    onClick={() => {
                                        if (fundRequestData?.reviewerStatusId === 10) {
                                            Swal.fire({
                                                icon: 'info',
                                                title: 'Pending for Review',
                                                text: 'This IOM is still pending for review.',
                                            });
                                        } else {
                                            //setIsModalVisible(true);
                                        }
                                        approveOrRejectFundRequest();
                                    }}
                                    stylingMode="default"
                                    type="success"
                                    className="mr-2"
                                //hint={iomData?.nextUserStatusText ? iomData?.nextUserStatusText : "Approve"}
                                />
                                {/* <Button
                                    text="Back to Draft"
                                    icon="back"
                                    onClick={async () => {
                                    }}
                                    stylingMode="default"
                                    type="danger"
                                    className="mr-2"
                                    hint="Back to Draft"
                                /> */}
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Back"
                                    icon="back"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Back'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className={'col-lg-9 col-md-6'}>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Request No.</div>
                                                    <div className='fieldvalue'>{fundRequestData?.serialNo}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:date-range-outline-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Created On</div>
                                                    <div className='fieldvalue'>{fundRequestData?.createdOn}M</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Site</div>
                                                    <div className='fieldvalue'>{fundRequestData?.projectName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Department</div>
                                                    <div className='fieldvalue'>{fundRequestData?.departmentName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="tabler:category-2" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Category</div>
                                                    <div className='fieldvalue'>{fundRequestData?.categoryName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-6 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:subject-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Subject</div>
                                                    <div className='fieldvalue'>{fundRequestData?.subject}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card' >
                            <div className='card-body'>
                                <DataGrid
                                    dataSource={fundRequestData?.items || []}
                                    columnAutoWidth
                                    showBorders
                                    showRowLines
                                    showColumnLines={false}
                                    noDataText="No details"
                                    className='selectable-grid'
                                    // rowTemplate instead of rowRender
                                    rowTemplate={(container, row) => {
                                        const { data } = row;

                                        // Create the main row (table row)
                                        const mainRow = document.createElement("tr");
                                        // mainRow.className = "dx-row dx-data-row dx-row-lines";
                                        mainRow.style.borderTop = "1px solid #dddddd";

                                        // Checkbox column alignment
                                        let checkboxCell = document.createElement("td");
                                        checkboxCell.style.width = "40px";
                                        renderCheckBoxCell(data, checkboxCell);
                                        mainRow.appendChild(checkboxCell);


                                        let serialNoCell = document.createElement("td");
                                        serialNoCell.textContent = data?.itemSerialNo;
                                        mainRow.appendChild(serialNoCell);

                                        // Vendor
                                        let vendorCell = document.createElement("td");
                                        vendorCell.textContent = data?.vendorName;
                                        mainRow.appendChild(vendorCell);

                                        // Bank + Branch
                                        let bankCell = document.createElement("td");
                                        bankCell.innerHTML = `<div>${data?.bankName}</div><div style="font-size:11px;color:#999">${data?.branchName || ""}</div>`;
                                        mainRow.appendChild(bankCell);

                                        // Ledger Balance Amt
                                        let balanceCell = document.createElement("td");
                                        balanceCell.style.textAlign = "right";
                                        balanceCell.textContent = data.balanceAmt != null ? data.balanceAmt.toLocaleString("en-IN") : "";
                                        mainRow.appendChild(balanceCell);

                                        // Recommended Amt
                                        let recommendedCell = document.createElement("td");
                                        recommendedCell.style.textAlign = "right";
                                        recommendedCell.textContent = data.recommendedAmt != null ? data.recommendedAmt.toLocaleString("en-IN") : "";
                                        mainRow.appendChild(recommendedCell);

                                        container.appendChild(mainRow);

                                        if (data?.isApproveRejectEnables) {

                                            // Add remarks row (spanning all columns)
                                            const subRow = document.createElement("tr");
                                            subRow.className = "dx-row actionbuttons";
                                            subRow.style.borderBottom = "1px solid #dddddd";

                                            let emptyCell = document.createElement("td");
                                            subRow.appendChild(emptyCell);

                                            let subCell = document.createElement("td");
                                            subCell.colSpan = 5;
                                            // subCell.innerHTML = `<div style="0px; color:#555; font-style:italic;">
                                            // <strong>Remarks:</strong> ${data.remarks || "No remarks"}
                                            // </div>`;
                                            renderApproveRejectRadioButtonCell(data, subCell);
                                            subRow.appendChild(subCell);

                                            container.appendChild(subRow);
                                        }
                                    }}
                                >
                                    <Selection mode="multiple" showCheckBoxesMode="always" />
                                    <Column dataField="itemSerialNo" caption="Sr no." />
                                    <Column dataField="vendorName" caption="Vendor" />
                                    <Column dataField="bankName" caption="Bank" />
                                    <Column dataField="balanceAmt" caption="Ledger Balance" />
                                    <Column dataField="recommendedAmt" caption="Recommended Amt." />
                                    <Column dataField="remarks" caption="Remarks" visible={false} />
                                </DataGrid>

                                <div className="row mt-4">
                                    {fundRequestData?.actionDetails?.map((stage, index) => (
                                        <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                            <div className="w-100">
                                                <label className="form-label">{stage?.status}</label>
                                                {stage?.approvers?.map((approver, i) => (
                                                    <input
                                                        key={i}
                                                        type="text"
                                                        className="form-control"
                                                        value={`${approver?.firstName + " " + approver?.lastName} (${approver?.designation})`}
                                                        readOnly
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 reviews'>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='mb-1 sub-title-color'>REMARKS</div>
                                <div class="list-group">
                                    WORK IN PROGRESS !
                                    {/* {remarkIOM?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="list-group-item list-group-item-action flex-column align-items-start" style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}
                                        >
                                            <div className='small mb-1' style={{ color: '#282c7d', fontWeight: '500' }}>
                                                {item.iomStatus === 'Recall' ? "Recall Requested" : item.iomStatus} by {item.userName}
                                            </div>
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <small>Message</small>
                                                <small>
                                                    {item.remarkDate
                                                        ? new Date(item.remarkDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }) +
                                                        ' ' +
                                                        new Date(item.remarkDate).toLocaleTimeString('en-GB', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : ''}
                                                </small>
                                            </div>
                                            <div className="small" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>{item.remarks}</div>
                                        </div>
                                    ))} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='web-page-footer'>
                    www.vishwasamudra.in
                </div>
            </div>
            <Popup
                visible={remarksPopup?.isModalVisible}
                onHiding={() => setRemarksPopup((prevState) => ({
                    ...prevState,
                    isModalVisible: false,
                }))}
                showTitle={true}
                title="Approval"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarksPopup?.remarks}
                            onInput={(e) => setRemarksPopup(prevState => {
                                return { ...prevState, remarks: e?.event?.target?.value?.slice(0, 300) || "" }
                            })}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={255}
                        />
                        <div style={{ fontSize: "12px", color: remarksPopup?.remarks?.length > 255 ? "red" : "#999" }}>
                            {remarksPopup?.remarks?.length}/255 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>
                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setRemarksPopup({
                                isModalVisible: false,
                            });
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={() => {
                            setFundRequestData(prevState => ({
                                ...prevState,
                                items: prevState.items.map(item =>
                                    (item.itemId === remarksPopup.itemId)
                                        ? { ...item, remarks: remarksPopup?.remarks || "" }
                                        : item
                                )
                            }));
                            setRemarksPopup((prevState) => ({
                                ...prevState,
                                isModalVisible: false,
                            }));
                        }}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>

        </Fragment >
    )
}
